import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../lib/adminAuth";
import { ErrorBanner } from "../../components/admin/AdminUI";

export default function MfaChallengePage() {
  const { mfaPending, verifyMfa, isAuthenticated, logout } = useAdminAuth();
  const [code, setCode] = useState("");
  const [apiError, setApiError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (!mfaPending && isAuthenticated) return <Navigate to="/admin" replace />;
  if (!mfaPending && !isAuthenticated) return <Navigate to="/admin/login" replace />;

  async function onSubmit(e) {
    e.preventDefault();
    setApiError(null);
    if (!/^\d{6}$/.test(code)) {
      setApiError({ message: "Voer een 6-cijferige TOTP-code in." });
      return;
    }
    setSubmitting(true);
    try {
      await verifyMfa(code);
      navigate("/admin", { replace: true });
    } catch (e) {
      setApiError(e);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4" data-testid="mfa-page">
      <div className="w-full max-w-sm rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
        <h1 className="text-xl font-semibold text-slate-900">Twee-staps-verificatie</h1>
        <p className="mt-1 text-xs text-slate-500">Voer de 6-cijferige code uit uw authenticator-app in.</p>
        <form className="mt-6 flex flex-col gap-4" onSubmit={onSubmit}>
          <ErrorBanner error={apiError} />
          <label className="block text-sm">
            <span className="font-medium text-slate-700">TOTP-code</span>
            <input
              type="text"
              inputMode="numeric"
              maxLength={6}
              autoComplete="one-time-code"
              data-testid="mfa-code-input"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
              className="mt-1 w-full rounded-md border border-slate-300 px-3 py-2 text-center text-lg tracking-[0.5em] focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-200"
            />
          </label>
          <button
            type="submit"
            disabled={submitting}
            data-testid="btn-mfa-submit"
            className="inline-flex justify-center rounded-md bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:opacity-60"
          >
            {submitting ? "Bezig…" : "Verifiëren"}
          </button>
          <button
            type="button"
            onClick={async () => { await logout(); navigate("/admin/login"); }}
            data-testid="btn-mfa-cancel"
            className="text-center text-xs text-slate-500 underline-offset-2 hover:underline"
          >
            Annuleren en afmelden
          </button>
        </form>
      </div>
    </div>
  );
}
